module.exports = __webpack_public_path__ + "img/learning-forest_logo.6a6c36d5.jpg";